import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SiteDto} from '../../objects/site.dto';
import {DataService} from '../../../../services/data.service';
import {ServiceTechnicianDtoModel} from '../../../../models/service-technician-dto.model';

@Component({
    selector: 'app-create-site-detail-modal',
    templateUrl: './create-site-detail-modal.component.html',
    styleUrls: ['./create-site-detail-modal.component.scss']
})
export class CreateSiteDetailModalComponent implements OnInit{
    @Input() public modalControl = { showModal: false };
    @Input() public isPlanner: boolean;
    @Input() public site: SiteDto;
    @Output() public updatedSite: EventEmitter<boolean> = new EventEmitter<boolean>();

    serviceTechnicians: ServiceTechnicianDtoModel[] = [];

    constructor(private dataService: DataService) {
    }

    async ngOnInit(): Promise<void> {
        this.serviceTechnicians = await this.dataService.getAllServiceTechnicians() as ServiceTechnicianDtoModel[];
    }

    closeModal() {
        this.modalControl.showModal = false;
    }

    canEdit(): boolean {
        return this.isPlanner && this.site && this.site.siteInstallationState === 'PLANNED';
    }

    canSaveSite(): boolean {
        return this.isPlanner && this.site && this.isNotBlank(this.site.street) &&
            this.isNotBlank(this.site.streetNumber) &&
            this.isNotBlank(this.site.postCode) && this.isNotBlank(this.site.city);
    }

    async saveSite() {
        if (this.canSaveSite()) {
            console.log('createPlannedSite')
            await this.dataService.createPlannedSite(this.site);
            this.updatedSite.emit(true);
            this.closeModal();
        }
    }

    editStreet(event: any) {
        this.site.street = event;
    }

    editStreetNumber(event: any) {
        this.site.streetNumber = event;
    }

    editPostCode(event: any) {
        this.site.postCode = event;
    }

    editCity(event: any) {
        this.site.city = event;
    }

    editAdditionalName(event: any) {
        this.site.additionalName = event;
    }

    editSalesforceId(event: any) {
        this.site.salesforceId = event;
    }

    editContactPersonName(event: any) {
        this.site.contactPersonName = event;
    }

    editContactPersonNumber(event: any) {
        this.site.contactPersonNumber = event;
    }

    editInstallationPersonEmail(event: any) {
        this.site.installationPersonEmail = event;
    }

    editInstallationWeek(event: any) {
        this.site.installationWeek = event;
    }

    editNotes(event: any) {
        this.site.note = event;
    }

    private isNotBlank(value: string): boolean {
        return value && value !== null && value !== "";
    }
}
